import React from 'react';
import SurveyTableRow from './SurveyTableRow';

const SurveyTable = ({items, onChange, onDelete, onDeleteInstances, onExport}) => (
    <div className="nv-list container">
        {items.map((item) => (<SurveyTableRow key={item.id} item={item}
            onDelete={onDelete} onDeleteInstances={onDeleteInstances} onExport={onExport} />))}
    </div>);

export default SurveyTable;
